import { render } from "./changeUnitModel.vue?vue&type=template&id=dfb3a556"
import script from "./changeUnitModel.vue?vue&type=script&lang=js"
export * from "./changeUnitModel.vue?vue&type=script&lang=js"

import "./changeUnitModel.vue?vue&type=style&index=0&id=dfb3a556&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__